import Vue from "vue";
import VueI18n, { LocaleMessages } from "vue-i18n";

Vue.use(VueI18n);

function loadLocaleMessages(): {
  [key: string]: VueI18n.LocaleMessages;
} {
  const locales = require.context(
    "./locales/" + (process.env.VUE_APP_INDUSTRY_ID || "1") + "/",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages: { [key: string]: LocaleMessages } = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale: string = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

export default new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || "en",
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en",
  messages: loadLocaleMessages(),
});
